<template>
  <i :class="getClassName" @click="$emit('click')"></i>
</template>

<script>
export default {
  name: 'font-awesome-icon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String
    }
  },
  computed: {
    getClassName() {
      if (!this.size) {
        return this.icon
      } else {
        return `${this.icon} fa-${this.size}`
      }
    }
  }
}
</script>
